<template>
  <tr>
    <!-- 日期 -->
    <td>{{ item.Date | dateFormat }}</td>

    <!-- 以下手機版不顯示 -->
    <!-- 星期 -->
    <td v-show="!isMobile">{{ item.Date | weekFormat }}</td>
    <!-- 部門 -->
    <td v-show="!isMobile">{{ department.Name }}</td>
    <!-- 人員 -->
    <td v-show="!isMobile">{{ user.Profile.Name }}</td>
    <!-- 專案名稱 -->
    <td v-show="!isMobile">{{ project.Name }}</td>
    <!-- 任務 -->
    <td v-show="!isMobile">{{ task && task.Name }}</td>
    <!-- 以上手機版不顯示 -->

    <!-- 工作內容 -->
    <td>{{ item.Content }}</td>

    <!-- 以下手機版不顯示 -->
    <!-- 預估時數 -->
    <!-- <td v-show="!isMobile">{{ item.EstimatedHours }}</td> -->
    <!-- 實際時數 -->
    <td v-show="!isMobile">{{ item | hoursFormatOfTaskWorkingItem }}</td>
    <!-- 執行狀況 -->
    <td v-show="!isMobile">{{ item.WorkStatus }}</td>
    <!-- 處理說明 -->
    <td v-show="!isMobile">{{ item.Report }}</td>
    <!-- 獎金實發 -->
    <td v-show="!isMobile">{{ displayBonus }}</td>
    <!-- 實發月份 -->
    <td v-show="!isMobile">
      <span v-show="item.BonusReleasedAt">
        {{ item.BonusReleasedAt | yearMonthFormat }}
      </span>
    </td>
    <!-- 以上手機版不顯示 -->

    <!-- 狀態 -->
    <td>{{ item.Status }}</td>

    <td>
      <v-btn
        class="ml-1 mr-1"
        color="white"
        text
        small
        @click.stop="view"
      >檢視</v-btn>
      <v-chip
        v-if="isDepartmentManagerVerifiable"
        color="red"
        small
      >待審核</v-chip>
      <v-chip
        v-if="isDepartmentManagerReviewable || isManagerReviewable"
        color="red"
        small
      >待審核</v-chip>
      <v-chip
        v-if="isReportable"
        color="red"
        small
      >待回報</v-chip>
      <v-chip
        v-if="isEmployeeCheckable"
        color="red"
        small
      >待確認</v-chip>
      <!-- 主管審核 -->
      <!-- 主管退回 -->
      <!-- 經理審核 -->
      <v-icon
        v-if="isEditable"
        class="ml-1 mr-1"
        @click.stop="editItem"
      >edit</v-icon>

      <v-tooltip
        top
        v-if="isRemovable"
      >
        <template v-slot:activator="{ on }">
          <span
            v-on="on">
            <v-icon
              :disabled="!canDeleteThisTaskWorkingItem"
              class="ml-1 mr-1"
              @click.stop="confirmDeleteItem"
            >delete</v-icon>
          </span>
        </template>
        <span v-if="!canDeleteThisTaskWorkingItem">無法刪除，日誌已審核獎金</span>
        <span v-else>刪除工作日誌</span>
      </v-tooltip>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from "vuex";
import filterMixin from "@/data/filters/filter-mixin.vue";
import AppDataSetting from '@/data/app-data-setting.js'
export default {
  mixins: [filterMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isEditable: false
  }),
  computed: {
    task() {
      return AppDataSetting.attachTaskWorkingItemTask(this, this.item)
    },
    department() {
      const findUserDepartment = user => {
        let departmentID = (
          this.userDepartments.find(o => o.UserID == user.ID) || {}
        ).DepartmentID;
        return this.departments.find(o => o.ID == departmentID) || {};
      };
      return findUserDepartment(this.user)
    },
    user() {
      return this.users.find(o => o.ID == this.item.UserID) || { Profile: {} };
    },
    project() {
      return this.projectsMap[this.task.ProjectID] || {};
    },
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    isReportable() {
      return (
        this.myLevel == 1 &&
        this.item.UserID == this.me.ID &&
        (this.item.Status == "" || this.item.Status == "主管退回")
      ) || (
        this.myLevel == 10 && 
        this.item.UserID == this.me.ID &&
        (this.item.Status == "" || this.item.Status == "獎金退回")
      );
    },
    isDepartmentManagerReviewable() {
      return (
        this.myLevel == 10 &&
        (this.item.Status == "主管確認中" || this.item.Status == "獎金退回" || this.item.Status == "主管重新確認") &&
        AppDataSetting.findUserDepartmentIDByID(this, this.item.UserID) == this.$store.getters.myDepartment.ID
      );
    },
    isEmployeeCheckable() {
      return (
        this.myLevel == 1 &&
        this.item.Status == "員工確認中" &&
        this.item.UserID == this.me.ID
      );
    },
    isDepartmentManagerVerifiable() {
      return this.myLevel == 10 && this.item.Status == "審核預排中";
    },
    isManagerReviewable() {
      return this.myLevel > 100 && this.item.Status == "獎金簽核中";
    },
    canDeleteThisTaskWorkingItem() {
      return this.item.Status != "獎金發放中" && this.item.Status != "已完成"
    },
    isMoneyVisible () {
      return this.myLevel >= 10 || this.item.UserID == this.me.ID
    },
    displayBonus () {
      return this.isMoneyVisible ? this.item.Bonus : '-'
    },
    // isEditable () {
    //   if (this.myLevel >= 1000 && this.item.Status != '已完成') return true; // 總經理以上都可以編輯
    //   return this.myLevel == 10 || (this.myLevel == 1 && (this.item.Status == '審核預排中' || this.item.Status == '主管確認中') && this.item.UserID == this.me.ID)  // 2023/10 突然說員工新增任務，主管確認前也要能編輯
    // },
    isRemovable () {
      return this.myLevel == 10 || (this.myLevel == 1 && this.item.Status == '審核預排中') 
    },
    ...mapGetters([
      "me",
      "userDepartments",
      "departments",
      "tasks",
      "users",
      "projects",
      "projectsMap",
      "canEditTask",
      "myLevel"
    ])
  },
  methods: {
    async getIsEditable() {
      return await this.$store.dispatch('canEditTaskWorkingItem', this.item)
    },
    view() {
      this.$store.state.UI.dialog.taskWorkingItemDetail.id = this.item.ID;
      this.$store.state.UI.dialog.taskWorkingItemDetail.isShow = true;
    },
    editItem() {
      this.$emit("edit", this.item.ID);
    },
    confirmDeleteItem() {
      if (!confirm("確定刪除「" + (this.item.Content || "") + "」?")) return;
      this.$emit("remove", this.item);
    }
  },
  watch: {
    item: {
      handler: async function() {
        this.isEditable = await this.getIsEditable()
      },
      immediate: true
    }
  }
};
</script>